<template>
	<!-- 
		@todo When we introduce this to the dashboard, we'll need to create a unified common-card.
		This currently relies on the plugin's common-card. 
	-->
	<common-card @dismiss="updateDismissed" class="playbooks-recommendation" type="dismiss">
		<!--eslint-disable vue/singleline-html-element-content-newline -->
		<div class="playbooks-recommendation__heading">
			<playbooks-svg-goal-target />
			{{ recommendation.title }}
		</div>
		<div :class="{ 'featured-recommendation': featuredLayout }" class="playbooks-table__container">
			<playbooks-playbook
				v-for="template in recommendation.playbooks"
				:key="template.slug"
				:template="template"
				:featured="featuredLayout"
				:class="cardClass"
				class="playbooks-card"
			/>
		</div>
	</common-card>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
	props: {
		recommendation: {
			type: Object,
			required: true,
		},
	},
	computed: {
		/**
		 * Determines the number of playbooks to display in the recommendation.
		 *
		 * @returns {int} The total number of playbooks for this recommendation.
		 */
		playbooksCount() {
			return this.recommendation.playbooks.length;
		},
		/**
		 * Determine the size of the cards to use based on the number of playbooks.
		 *
		 * If there is only one playbook, use the large card size.
		 * If there are two playbooks, use the medium card size.
		 * If there are three playbooks, use the small card size.
		 *
		 * @returns {string} The card class to use.
		 */
		cardClass() {
			return {
				'playbooks-card__large': 1 === this.playbooksCount,
				'playbooks-card__medium': 2 === this.playbooksCount,
				'playbooks-card__small': 3 <= this.playbooksCount,
			};
		},
		/**
		 * Determines whether we are featuring a single playbook in the recommendation block.
		 *
		 * @returns {boolean} true if we are featuring a single playbook, false otherwise.
		 */
		featuredLayout() {
			return 1 === this.recommendation.playbooks.length;
		},
	},
	methods: {
		...mapMutations('playbooks', ['setDismissedRecommendations']),
		/**
		 * Updates the dismissed recommendations in the store and the cookie.
		 *
		 * @returns {void}
		 */
		updateDismissed() {
			this.setDismissedRecommendations(this.recommendation.slug);
		},
	},
};
</script>
